// extracted by mini-css-extract-plugin
module.exports = {"post-date":"PostDate_post-date__AzCsZ"};